const Portal = {
  LOCQ: "locq",
  FLEET: "fleet",
  OILCO: "oilco",
  STATION: "station",
  PRICETRACQ: "pricetracq",
  BOS: "bos",
  HOS: "hos",
};

export default Portal;
